export var SummaryGuidelinesStatus;
(function (SummaryGuidelinesStatus) {
    SummaryGuidelinesStatus["PENDING"] = "pending";
    SummaryGuidelinesStatus["COMPLETE"] = "complete";
    SummaryGuidelinesStatus["NONE"] = "none";
})(SummaryGuidelinesStatus || (SummaryGuidelinesStatus = {}));
export const PENDING_GENERATION = "PENDING_GENERATION";
